import { useState } from 'react';
import { Skeleton } from '@mui/material';
import { VideoPlayer } from '@/components/shared/video-player';
import { useLessons } from '@/packages/corporate-university/context/lessons';

const VideoLessonSkeleton = () => {
  return <Skeleton variant="rounded" height={400} />;
};
export const VideoLesson = () => {
  const {
    isLoadingCourse,
    lessonVideo,
    handleUpdateLessonProgress,
    currentLesson,
  } = useLessons();
  const [progress, setProgress] = useState(0);

  const handleProgress = (percentage: number) => {
    setProgress(percentage);
  };

  const handlePause = () => {
    handleUpdateLessonProgress({ lessonId: currentLesson?.id ?? '', progress });
  };

  return isLoadingCourse ? (
    <VideoLessonSkeleton />
  ) : (
    <VideoPlayer
      url={lessonVideo ?? ''}
      onProgress={handleProgress}
      onPause={handlePause}
    />
  );
};
